import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material';
import ObjectSelectPicker from './ObjectSelectPicker';
/**
 * `ObjectSelectPicker` with an avatar in front of every option. The behaviour - the dependency
 * chain, defaultValue, the placeholder, keeping the selection valid against the options actually
 * on offer - all lives in that picker; this file is only the renderer and the styling that a
 * full-size option row needs.
 */
export default function ObjectSelectAvatarPicker(props) {
    const theme = useTheme();
    // one option row: the avatar and the name, styled like a list item in ObjectListPicker
    const renderOption = (row) => {
        var _a, _b;
        return (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', width: '100%' }, children: [_jsx(Avatar, { variant: (_b = (_a = props.config) === null || _a === void 0 ? void 0 : _a.imageVariant) !== null && _b !== void 0 ? _b : 'circular', src: row.image, sx: {
                        width: 56,
                        height: 56,
                        marginRight: 2,
                        color: 'inherit'
                    } }), _jsx(Typography, { component: "span", sx: {
                        fontSize: '1.25rem',
                        fontWeight: 700,
                        color: 'inherit'
                    }, children: row.name })] }));
    };
    // the prompt is read at the same size as an option row, so the closed select does not
    // change height once something is picked
    const renderPlaceholder = (text) => (_jsx(Typography, { component: "span", sx: {
            fontSize: '1.25rem',
            fontWeight: 700,
            color: theme.palette.text.secondary
        }, children: text }));
    return (_jsx(ObjectSelectPicker, Object.assign({}, props, { renderOption: renderOption, renderPlaceholder: renderPlaceholder, 
        // no floating label: the option row uses the full height of the control
        hideLabel: true, sx: {
            // the dropdown arrow is scaled up to match the taller row
            "& .MuiSelect-select.MuiSelect-select": {
                display: 'flex',
                alignItems: 'center',
                minHeight: '56px',
                padding: '8px 56px 8px 14px'
            },
            "& .MuiSelect-icon": {
                fontSize: '2.25rem',
                right: '10px'
            }
        }, menuPaperSx: {
            backgroundColor: theme.palette.background.default,
            "& .MuiList-root": {
                paddingTop: 0,
                paddingBottom: 0
            },
            "& .MuiMenuItem-root": {
                transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                paddingY: 1,
                alignItems: 'center',
                borderBottom: theme.palette.mode === 'dark' ? '#333 1px solid' : '#f1f1f1 1px solid',
                backgroundColor: theme.palette.background.default,
                color: theme.palette.text.primary
            },
            "& .MuiMenuItem-root:hover, & .MuiMenuItem-root.Mui-focusVisible": {
                backgroundColor: theme.palette.mode === 'dark'
                    ? theme.palette.primary.light
                    : theme.palette.primary.dark,
                color: theme.palette.primary.contrastText
            },
            "& .MuiMenuItem-root.Mui-selected, & .MuiMenuItem-root.Mui-selected:hover, & .MuiMenuItem-root.Mui-selected.Mui-focusVisible": {
                backgroundColor: theme.palette.primary.main,
                color: theme.palette.primary.contrastText
            }
        } })));
}
